import React, { useEffect } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { LoadingOverlay } from '@uhg-abyss/web/ui/LoadingOverlay';
import { saveTokenToStorage } from '@src/utills/storage';
import { API } from '@src/api';
import { IconBrand } from '@uhg-abyss/web/ui/IconBrand';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Text } from '@uhg-abyss/web/ui/Text';
export const LoginCallBack = () => {
  const { getRouteParams } = useRouter();
  const { navigate } = useRouter();

  const params = getRouteParams();

  const requestToken: string | undefined = params.request_token ?? undefined;
  const [textMsg, setTextMsg] = React.useState('Validating......');
  useEffect(() => {
    API.requestToken(requestToken).then((res: any) => {
      if (res !== null && res?.status !== 'error' && 'token' in res) {
        saveTokenToStorage(res.token);
        navigate('/redirect');
      } else {
        setTextMsg(res?.response?.data?.description);
      }
    });
  }, []);
  return (
    <React.Fragment>
      <LoadingOverlay width={400} model="useOverlay-loading" />
      <Layout.Stack alignLayout="left" style={{ display: 'block' }}>
        <div
          style={{
            marginTop: '2rem',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <IconBrand size={128} icon="lock" />
        </div>
        <div
          style={{ padding: '2rem', justifyContent: 'center', display: 'flex' }}
        >
          <Text as="label" color="black" fontSize="md">
            <div dangerouslySetInnerHTML={{ __html: textMsg }}></div>
          </Text>
        </div>
      </Layout.Stack>
    </React.Fragment>
  );
};
